<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M3.8 14.2 14.2 3.8a2 2 0 0 1 2.8 0l3.2 3.2a2 2 0 0 1 0 2.8L9.8 20.2a2 2 0 0 1-2.8 0l-3.2-3.2a2 2 0 0 1 0-2.8z" />
    <path d="m8 10 2 2" />
    <path d="m11 7 2 2" />
    <path d="m5 13 2 2" />
  </svg>
</template>
